var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFullScreen01 = function SvgFullScreen01(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.1 27.1",
    enableBackground: "new 0 0 27.1 27.1",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0,0v27.1h27.1V0H0z M2.3,2.3l6.5,0v1.7l-3.5,0l6.1,6.1l-1.2,1.2L4.1,5.3l0,3.5l-1.7,0L2.3,2.3z M8.8,24.8 l-6.5,0l0-6.5l1.7,0l0,3.5l6.1-6.1l1.2,1.2L5.3,23l3.5,0V24.8z M24.8,24.8l-6.5,0V23l3.5,0l-6.1-6.1l1.2-1.2l6.1,6.1l0-3.5l1.7,0 L24.8,24.8z M23,8.8l0-3.5l-6.1,6.1l-1.2-1.2l6.1-6.1l-3.5,0V2.3l6.5,0l0,6.5L23,8.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.4,16.9 10.2,15.7 4.1,21.8 4.1,18.3 2.3,18.3 2.3,24.8 8.8,24.8 8.8,23 5.3,23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.1,5.3 10.2,11.4 11.4,10.2 5.3,4.1 8.8,4.1 8.8,2.3 2.3,2.3 2.3,8.8 4.1,8.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23,21.8 16.9,15.7 15.7,16.9 21.8,23 18.3,23 18.3,24.8 24.8,24.8 24.8,18.3 23,18.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.3,2.3 18.3,4.1 21.8,4.1 15.7,10.2 16.9,11.4 23,5.3 23,8.8 24.8,8.8 24.8,2.3  "
  }))));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFullScreen01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/full_screen-01.3364a732.svg";
export { ForwardRef as ReactComponent };